/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGlassHalfEmptyS = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 2c2.536 0 4.862.227 6.581.61.851.189 1.608.427 2.177.726.283.149.569.338.795.584.23.25.447.616.447 1.08 0 .17-.03.325-.078.468l-2.927 13.659c-.048.649-.455 1.127-.848 1.437-.428.338-.987.599-1.588.8-1.213.403-2.825.636-4.559.636s-3.346-.233-4.559-.637c-.6-.2-1.16-.461-1.588-.8-.393-.309-.801-.787-.85-1.436L2.078 5.467A1.46 1.46 0 0 1 2 5c0-.464.216-.83.447-1.08.226-.246.512-.435.795-.584.569-.299 1.326-.537 2.177-.727C7.138 2.227 9.464 2 12 2zm7.517 5.148c-.295.089-.608.17-.936.243C16.862 7.773 14.536 8 12 8c-2.536 0-4.862-.227-6.581-.61a13.454 13.454 0 0 1-.937-.242l1.501 7.004C7.24 14.621 9.327 15 12 15c2.838 0 4.81-.429 6.036-.944zM12 4c-2.435 0-4.609.22-6.147.562-.625.138-1.11.29-1.454.438.344.147.829.3 1.454.438C7.39 5.78 9.565 6 12 6s4.609-.22 6.147-.562c.625-.138 1.109-.29 1.453-.438-.344-.147-.828-.3-1.452-.438C16.608 4.22 14.434 4 12 4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgGlassHalfEmptyS as GlassHalfEmptyS };
